import React from "react";
import { useTranslate } from "react-admin";

const OrderTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("order.message.list") :
                ! record.id ? translate("order.message.new") :
                              translate("order.message.instance", { ...record })
            }
        </span>
    );
}

export default OrderTitle;
